export default "__VITE_ASSET__BKxttDjc__"